// extracted by mini-css-extract-plugin
export default {"mainnav-container":"MainNavigation_mainnav-container__zhDIu","left":"MainNavigation_left__-8+8O","right":"MainNavigation_right__pus-M","active":"MainNavigation_active__5tzso"};